









































import VueOptions from '@utils/VueOptions'
import IndicatorUtility from '@utils/IndicatorUtility'

settings =
  name: 'IndicatorCard'

  vue:
    props: ['item', 'options', 'actions']

    computed:
      title: -> @item.title
      message: -> @item.message

      indicatorIcon: ->
        IndicatorUtility.iconFor @item

      indicatorStatus: ->
        IndicatorUtility.statusFor @item

    methods:
      hiTrust: ->
        @actions?.trust @item
      hiUntrust: ->
        @actions?.untrust @item

      hiNavToResource: ->
        { name, params, query } = IndicatorUtility.routeFor @item
        { href } = @$router.resolve { name, params, query }
        window.open href, '_blank'

      formatTitle: (value) ->
        @$options.filters.formatTitle value

      formatDateTime: (date) ->
        dayjs(date).format('MM-DD-YYYY HH:mm')

export default VueOptions.vue settings
